{
  "title": "Support",
  "subtitle": "Create and track your support requests.",
  "newTicket": "New ticket",
  "newReply": "New reply",
  "quick": {
    "heading": "Quick actions",
    "trackOrder": {
      "label": "Track Order",
      "caption": "Check the status or location of an order.",
      "subject": "Track my order",
      "description": "I'd like to check the current status and location of my order. Order number: "
    },
    "startReturn": {
      "label": "Start Return",
      "caption": "Request a return or refund for an order.",
      "subject": "Start a return",
      "description": "I'd like to start a return or refund for my order. Order number: \nReason: "
    },
    "orderIssues": {
      "label": "Order Issues",
      "caption": "Report a problem with a product or delivery.",
      "subject": "Issue with my order",
      "description": "I'm having an issue with a product in my order. Order number: \nWhat went wrong: "
    },
    "paymentHelp": {
      "label": "Payment Help",
      "caption": "Get help with billing or payments.",
      "subject": "Payment / billing help",
      "description": "I need help with a payment or billing matter. Please describe your question: "
    }
  },
  "tabs": {
    "all": "All",
    "Open": "Open",
    "InProgress": "In progress",
    "Resolved": "Resolved",
    "Closed": "Closed"
  },
  "status": {
    "Open": "Open",
    "InProgress": "In progress",
    "Resolved": "Resolved",
    "Closed": "Closed",
    "Reopened": "Reopened"
  },
  "category": {
    "Order": "Order",
    "Billing": "Billing",
    "Product": "Product",
    "Account": "Account"
  },
  "priority": {
    "Critical": "Critical",
    "High": "High",
    "Medium": "Medium",
    "Low": "Low"
  },
  "filters": {
    "issueType": "Issue type",
    "allTypes": "All types",
    "refresh": "Refresh"
  },
  "card": {
    "order": "Order:",
    "replies": "Replies",
    "updated": "Updated {{time}}"
  },
  "table": {
    "subject": "Subject",
    "category": "Category",
    "priority": "Priority",
    "status": "Status",
    "updated": "Updated",
    "ticketNumber": "Ticket #"
  },
  "list": {
    "loading": "Loading…",
    "error": "Could not load the ticket list.",
    "empty": "No tickets yet.",
    "searchPlaceholder": "Search by ticket # or subject..."
  },
  "modal": {
    "title": "Create support ticket",
    "subjectLabel": "Subject",
    "subjectPlaceholder": "Summarize your issue",
    "categoryLabel": "Category",
    "priorityLabel": "Priority",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Describe the issue you ran into in detail",
    "cancel": "Cancel",
    "submit": "Create ticket",
    "submitting": "Creating…",
    "error": "Failed to create ticket.",
    "orderLabel": "Related order (optional)",
    "orderNone": "— No order —",
    "orderSearchPlaceholder": "Search orders…",
    "orderNoResults": "No orders found",
    "orderSelectedCount": "{{count}} order(s) linked",
    "orderRemove": "Remove {{order}}"
  },
  "detail": {
    "back": "Ticket list",
    "loading": "Loading…",
    "notFound": "Ticket not found.",
    "createdAt": "Created {{date}}",
    "you": "You",
    "agent": "Support",
    "closed": "Ticket closed.",
    "replyPlaceholder": "Type a reply…",
    "send": "Send",
    "sending": "Sending…",
    "resolutionTitle": "Resolution",
    "conversation": "Conversation",
    "detailsHeading": "Details",
    "fieldStatus": "Status",
    "fieldPriority": "Priority",
    "fieldCategory": "Category",
    "fieldOrder": "Order",
    "fieldAssignee": "Assigned to",
    "fieldCreated": "Created",
    "fieldUpdated": "Updated",
    "unassigned": "Unassigned",
    "ticketInfo": "Ticket Info",
    "fieldIssueType": "Issue Type",
    "fieldLastUpdated": "Last Updated",
    "relatedOrders": "Related Orders",
    "noRelatedOrders": "No related orders",
    "activityTimeline": "Activity Timeline",
    "ticketCreated": "Ticket created",
    "supportReplied": "Support replied",
    "noMessages": "No messages yet.",
    "resolvedPrompt": "Support marked this ticket as resolved. Are you satisfied?",
    "reopenBtn": "Not satisfied — reopen",
    "reopenCommentPlaceholder": "Tell us what is still wrong (optional)",
    "reopenSubmit": "Reopen ticket",
    "reopenCancel": "Cancel",
    "confirmCloseBtn": "Confirm & close",
    "sent": "Sent",
    "read": "Read",
    "viewAll": "View all ({{count}})",
    "showLess": "Show less",
    "closeTicket": "Close Ticket",
    "download": "Download",
    "moreActions": "More actions",
    "attachments": "Attachments",
    "composePlaceholder": "Type your message… (Paste images with Ctrl+V)",
    "youReplied": "You replied",
    "ticketReopened": "Ticket reopened",
    "preferredResolution": "Preferred resolution: {{value}}"
  },
  "compose": {
    "keyboardHint": "Enter to send · Option+Enter for a new line",
    "attach": "Attach file",
    "uploading": "Uploading…",
    "removeAttachment": "Remove {{filename}}",
    "linkOrder": "Link order",
    "searchOrder": "Search order…",
    "noOrders": "No orders found",
    "uploadFailTitle": "Could not upload file",
    "fileTooLarge": "File exceeds the 10MB limit",
    "fileTypeForbidden": "This file type is not allowed",
    "download": "Download",
    "imageAlt": "Attached image",
    "attachDisabledHint": "Attachments are only available while the dispatch is active"
  },
  "stats": {
    "all": "All tickets",
    "open": "Open",
    "inProgress": "In progress",
    "resolved": "Resolved"
  },
  "resolution": {
    "Reprint": "Reprint",
    "FullRefund": "Full refund",
    "PartialRefund": "Partial refund",
    "StoreCredit": "Store credit",
    "Replacement": "Replacement",
    "ShippingCredit": "Shipping credit",
    "NoActionRequired": "No action required",
    "Escalated": "Escalated"
  },
  "rating": {
    "prompt": "How was our support? Rate this ticket:",
    "starAria": "{{count}} stars",
    "commentPlaceholder": "Optional comment...",
    "submit": "Submit rating",
    "submitting": "Submitting...",
    "thanks": "Thanks for your feedback!",
    "invite": "This ticket has been resolved — we'd love your feedback!",
    "inviteCta": "Rate our support",
    "modalTitle": "Rate our support",
    "overall": "Overall satisfaction",
    "surveyResponsiveness": "Response speed",
    "surveyHelpfulness": "Was your issue resolved?",
    "surveyProfessionalism": "Agent professionalism",
    "cancel": "Cancel"
  },
  "realtime": {
    "tabFlash": "Ticket update",
    "updateTitle": "Support ticket update",
    "updateBody": "Your ticket has a new reply."
  },
  "dispatch": {
    "title": "Dispatch to vendor / department",
    "target": {
      "vendor": "Vendor",
      "department": "Internal department"
    },
    "department": {
      "Finance": "Finance",
      "IT": "IT",
      "Logistics": "Logistics",
      "Product": "Product"
    },
    "status": {
      "Dispatched": "Dispatched",
      "InProgress": "In progress",
      "Returned": "Returned",
      "Cancelled": "Cancelled"
    },
    "pickVendor": "Select a vendor",
    "scopeNotePlaceholder": "Describe the task for the handler (no merchant PII for vendors)",
    "replyPlaceholder": "Reply in this dispatch thread…",
    "submit": "Dispatch",
    "cancel": "Cancel",
    "send": "Send",
    "return": "Return to support",
    "recall": "Recall",
    "empty": "No dispatches",
    "navTitle": "Dispatch queue",
    "toast": {
      "created": "Dispatch created",
      "error": "Action failed"
    }
  },
  "linkOrder": {
    "title": "Link Order",
    "searchPlaceholder": "Search orders by number…",
    "link": "Link",
    "unlink": "Unlink",
    "empty": "No orders found",
    "linked": "Linked orders"
  }
}
